import {css} from '@yandex-delivery/blocks/theme/css'
import {spacing} from '@yandex-delivery/blocks/theme/theme'

export const classes = {
  root: css`
    min-block-size: ${spacing(7)}; // 56px
  `,
  switch: css`
    margin-inline-start: ${spacing(2)}; // 16px
  `,
}
